export const OGI_NEAR_PLUME_RADIUS_M = 500;
export const OGI_NEAR_RASTER_RADIUS_M = 500;